<template>
  <div class="manual-google-cv-07-01">
    <h2>成果データのダウンロード方法（Felmat）</h2>
    <el-row>
      <el-col>
        <h4>
          【１】
          <a href="https://www.felmat.net/publisher/login" target="_blank"
            >Felmatの管理画面</a
          >
          にログインし、「成果発生」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no01/01.png`" alt="" />
        <h4>【２】「成果発生」画面からCSVをダウンロードします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no01/02.png`" alt="" />
        <h4>
          【３】成果が表示されたら、「計測用パラメータ」にクリックパラメータ（{{tool.clickIdName}}_xxx）が表示されているか確認します。
        </h4>
        <img :src="`${rt}/img/manual/${tool.codeKebab}/no07/no01/03.png`" alt="" />
        <p class="red">
          ※パラメータが表示されていない場合、パラメータ引継ぎ設定を間違えている可能性があります。
        </p>
        <p>
          「<router-link :to="`/manual/${tool.codeKebab}/06/02`">パラメータ引継ぎタグを設置する</router-link
          >」をご確認ください。
        </p>
        <h4>
          【４】CSVをダウンロードします。「上記条件でCSVダウンロード」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no01/04.png`" alt="" />
        <p>
          これで成果CSVのダウンロードは完了です。「<router-link
            :to="`/manual/${tool.codeKebab}/07/14`"
            >ASPの成果データをアドタスカルにインポートする</router-link
          >」に進んでください。
        </p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ManualGoogleCvContents",
  props: {},
  computed: {
    ...mapGetters(["rt","tool"]),
    tools() {
      return this.$store.getters.tools;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 40px;
  margin-bottom: 15px;
}

img {
  width: 95%;
  margin-left: 40px;
  border: 3px solid gray;
}
</style>
